import type { AppSession } from "./session";

/**
 * Cross-module, cross-navigator session overlay. JS module-level singleton —
 * every mounted `SessionProvider` in the process reads and writes through the
 * same `patch` object, so `updateSession` from one tree is visible in every
 * other tree.
 */
let patch: Partial<AppSession> = {};
let patchVersion = 0;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export function subscribeSessionPatch(onStoreChange: () => void) {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
}

export function getSessionPatchVersion(): number {
  return patchVersion;
}

export function getSessionPatchSnapshot(): Partial<AppSession> {
  return patch;
}

export function mergeSessionPatch(updates: Partial<AppSession>): void {
  patch = { ...patch, ...updates };
  patchVersion += 1;
  emit();
}

export function resetSessionPatch(): void {
  patch = {};
  patchVersion += 1;
  emit();
}
